export const TIMEZONE_FALLBACKS = {
  tz3: ["tz3", "tz2", "tz1", "tz0"],
  tz2: ["tz2", "tz1", "tz0"],
  tz1: ["tz1", "tz0"],
  tz0: ["tz0"],
};

export function getFallbackOrder(selectedTZ) {
  if (!selectedTZ) return ["tz1", "tz2", "tz0"];
  return TIMEZONE_FALLBACKS[selectedTZ] || [selectedTZ, "tz1", "tz2", "tz0"];
}

export function collectSubjectKeys(timezones = {}) {
  const keys = new Set();
  Object.values(timezones).forEach(zone => {
    if (!zone) return;
    Object.keys(zone).forEach(key => keys.add(key));
  });
  return Array.from(keys);
}

export function findSubjectKey(timezones, predicate) {
  if (!predicate) return null;
  return collectSubjectKeys(timezones).find(predicate) || null;
}

export function getEntryForSubject(timezones, subjectKey, selectedTZ) {
  if (!subjectKey) {
    return { entry: null, zone: null };
  }

  const order = getFallbackOrder(selectedTZ);
  for (const zone of order) {
    const entry = timezones?.[zone]?.[subjectKey];
    if (entry) {
      return { entry, zone };
    }
  }

  for (const [zone, zoneEntries] of Object.entries(timezones || {})) {
    if (order.includes(zone)) continue;
    const entry = zoneEntries?.[subjectKey];
    if (entry) {
      return { entry, zone };
    }
  }

  return { entry: null, zone: null };
}

export function findEntry(timezones, predicate, selectedTZ) {
  const subjectKey = findSubjectKey(timezones, predicate);
  const { entry, zone } = getEntryForSubject(timezones, subjectKey, selectedTZ);
  return { entry, zone, subjectKey };
}
